import { GlobalEvents } from "../../globalEvents";
import GlobalEvent from "./GlobalEvent";
export class GlobalEventsHandler {
    constructor() {
        this.events = {};
    }
    createGlobalEvent(name) {
        if (!this.events[name]) {
            this.events[name] = this.getNewEvent(name);
        }
        return this.events[name];
    }
    // Event when cart is loaded
    getCartLoadEvent() {
        return this.createGlobalEvent(GlobalEvents.CartIdLoaded);
    }
    getCartActive() {
        return this.createGlobalEvent(GlobalEvents.CartIsActive);
    }
    // Event when limit is reached by product
    getProductLimitEvent() {
        return this.createGlobalEvent(GlobalEvents.ProductLimitReached);
    }
    // Even when global InfoBanner close event
    getInfoBanerActiveEvent() {
        return this.createGlobalEvent(GlobalEvents.InfoBannerStateChange);
    }
    updateLoyaltyPoints() {
        return this.createGlobalEvent(GlobalEvents.UpdateLoyaltyPoints);
    }
    /**
     * S : registration type
     * T : success response type
     * U : failure response type
     * @param name of event
     * @private
     */
    getNewEvent(name) {
        return new GlobalEvent(name);
    }
}
export const globalEventsHandler = new GlobalEventsHandler();
//# sourceMappingURL=GlobalEventsHandler.js.map